import {
  BadgeColor,
  FEATURE,
  type Feature,
  TESLA_FLEET_VEHICLE_STATUS,
  type TeslaFleetVehicleStatus,
} from "@lyteflo/types";

export const TESLA_TAB = {
  QUICK_LOOKUP: "quickLookup",
  FLEET: "fleet",
} as const;

export type TeslaTab = (typeof TESLA_TAB)[keyof typeof TESLA_TAB];

export const TESLA_TABS = [
  TESLA_TAB.FLEET,
  TESLA_TAB.QUICK_LOOKUP,
] as const satisfies readonly TeslaTab[];

export const TESLA_TAB_FEATURE = {
  [TESLA_TAB.QUICK_LOOKUP]: FEATURE.VIEW_TESLA_QUICK_LOOKUP,
  [TESLA_TAB.FLEET]: FEATURE.VIEW_TESLA_OTA,
} as const satisfies Record<TeslaTab, Feature>;

// Hold none of these and the page has no tab to show, so the nav entry has to
// go with them.
export const TESLA_TAB_FEATURES: readonly Feature[] =
  Object.values(TESLA_TAB_FEATURE);

export const TESLA_TAB_PARAM = "tab";

export const VIN_LIST_SEPARATOR = /[\s,;]+/;

export const ENTER_KEY = "Enter";

export const TAB_KEY = {
  LEFT: "ArrowLeft",
  RIGHT: "ArrowRight",
  HOME: "Home",
  END: "End",
} as const;

export const TESLA_FLEET_DATE_FORMAT = {
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
} as const;

export const TESLA_FLEET_VEHICLE_STATUS_COLOR = {
  [TESLA_FLEET_VEHICLE_STATUS.READY]: BadgeColor.blue,
  [TESLA_FLEET_VEHICLE_STATUS.WAITING_ON_OWNER]: BadgeColor.gray,
  [TESLA_FLEET_VEHICLE_STATUS.NEEDS_VIRTUAL_KEY]: BadgeColor.yellow,
  [TESLA_FLEET_VEHICLE_STATUS.NEEDS_SAFETY_TOGGLE]: BadgeColor.yellow,
  [TESLA_FLEET_VEHICLE_STATUS.NEEDS_FIRMWARE_UPDATE]: BadgeColor.yellow,
  [TESLA_FLEET_VEHICLE_STATUS.AT_CONFIG_LIMIT]: BadgeColor.yellow,
  [TESLA_FLEET_VEHICLE_STATUS.ASLEEP]: BadgeColor.gray,
  [TESLA_FLEET_VEHICLE_STATUS.OFFLINE]: BadgeColor.gray,
  [TESLA_FLEET_VEHICLE_STATUS.EMAIL_FAILED]: BadgeColor.red,
  [TESLA_FLEET_VEHICLE_STATUS.EXPIRED]: BadgeColor.red,
  [TESLA_FLEET_VEHICLE_STATUS.CANCELLED]: BadgeColor.gray,
  [TESLA_FLEET_VEHICLE_STATUS.UNSUPPORTED]: BadgeColor.red,
  [TESLA_FLEET_VEHICLE_STATUS.UNKNOWN]: BadgeColor.gray,
} as const satisfies Record<TeslaFleetVehicleStatus, BadgeColor>;

/** Twice the drawn size, so the code stays sharp on a HiDPI screen. */
export const TESLA_PAIRING_QR_RENDER_WIDTH = 208;

export const TESLA_GENERATION_BLOCK = {
  NOT_SINGLE_DEALERSHIP: "notSingleDealership",
  DEALERSHIP_CONFIG_UNAVAILABLE: "dealershipConfigUnavailable",
  RUN_STATE_UNKNOWN: "runStateUnknown",
} as const;

export type TeslaGenerationBlock =
  (typeof TESLA_GENERATION_BLOCK)[keyof typeof TESLA_GENERATION_BLOCK];
